import React, {Fragment, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {Button, Container, Header, Image} from "semantic-ui-react";
import TinySlider from "tiny-slider-react";

import {APP} from '../../../constants';
import {fetchPlaces} from "../../../redux/actions";
import {FormattedMessage} from "react-intl";
import moment from "moment";

export const Events = ({city_id}) => {

    const [events, setEvents] = useState([]);

    useEffect(() => {

        const fetchData = async () => {

            try {

                // get posts
                const result = await fetchPlaces({
                    city_id,
                    from: 'events',
                    limit: 6,
                });

                // set posts
                setEvents(result.data.data);

            } catch (e) {

                // show errors
                console.log('error', e);
            }
        };

        // noinspection JSIgnoredPromiseFromCall
        fetchData();

    }, [city_id]);

    const settings = {
        lazyload: true,
        nav: false,
        controls: false,
        mouseDrag: true,
        controlsText: ["<", ">"],
        loop: true,
        items: 1,
        gutter: 20,
        responsive: {
            420: {
                items: 1
            },
            960: {
                items: 3
            }
        }
    };

    if(events.length === 0){

        return (
            <Fragment />
        );
    }

    return (
        <Container as="section" className="section-events">
            <Header as="h2"><FormattedMessage id="Eventos agendados"/></Header>
            <div
                style={{
                    width: "100%",
                    position: "relative"
                }}
            >
                <TinySlider settings={settings}>
                    {
                        events.map((event) => {

                            const {id, name, about, slug, start, banner, local} = event;
                            let text = about ? about.replace(/<[^>]+>/g, '').substr(0, 165)+"... " : "";
                            let image = APP.images.places.small;
                            if (banner) {
                                image = APP.images.places.path + banner.replace('big', 'small');
                            }

                            const time = moment(start).utc(1);

                            return (
                                <Link to={`/events/details/${id}/${slug}`} key={`event-${id}`}>
                                    <div style={{position: "relative", marginBottom: 8}}>
                                        <Image src={image}/>
                                    </div>

                                    <p className={"excerpt"} style={{color: '#000', marginBottom: 0}}>{time.format('DD/MM \à\\s HH:mm')}</p>
                                    <Header as="h3" className={'no-bar'} style={{marginTop: 4, marginBottom: 8}}>{name}</Header>
                                    {/*<p>{local}</p>*/}
                                    <p
                                        className={"excerpt"}
                                    >
                                        <span
                                            dangerouslySetInnerHTML={{__html: text}}
                                            style={{
                                                color: '#000'
                                            }}
                                        />
                                        [<FormattedMessage id="leia mais"/>]
                                    </p>
                                </Link>
                            )
                        })
                    }
                </TinySlider>
            </div>
            <Link to={'/events'}>
                <Button color="orange" size="big">
                    <FormattedMessage id="Ver todos"/>
                </Button>
            </Link>
        </Container>
    );
};
